// This file is auto-generated during build
export const PACKAGE_VERSION = "1.35.0";
